import React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import CTAList from 'components/common/CTAList'

export default function RichtextCTA({ content, ctas }) {
	return (
		<div className="bg-suede-black p-8 text-white">
			<SanityBlock body={content} />
			<CTAList ctas={ctas} className="mt-6 text-sm" />
		</div>
	)
}
